module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/manage-group/manage-group.component.css
// module id = ./src/app/shared/components/manage-group/manage-group.component.css
// module chunks = main